<template>
  <div class="create-item-title">
    <div class="num">{{num}}</div>
    <div class="txt">{{title}}</div>
  </div>
</template>

<script>
export default {
  name: 'createTitle',
  props: {
    num: {
      type: Number,
      default: 1,
    },
    title: String,
  },
};
</script>

<style lang="less">
  .create-item-title{
    display: flex;
    align-items: center;
    .num{
      width: 40px;
      height: 40px;
      text-align: center;
      line-height: 40px;
      background-color: rgba(0, 0, 0, 0.08);
      color: rgb(81, 69, 139);
      font-size: 18px;
      border-radius: 50%;
    }
    .txt{
      padding-left: 16px;
      color: rgb(81, 69, 139);
      font-size: 18px;
    }
  }
</style>
